import MAClosingSummaryPage from './MAClosingSummaryPage'
// Uncomment the below to migrate to stateful component
// import MAClosingSummaryPageContainer from './MAClosingSummaryPageContainer'

export { MAClosingSummaryPage }
export default MAClosingSummaryPage
// Uncomment the below to migrate to stateful component
// export { MAClosingSummaryPageContainer }
// export default { MAClosingSummaryPageContainer }
